"use strict";

exports.__esModule = true;
exports.WellTitle = exports.Well = exports.TooltipWell = exports.LegendsWell = exports.AxisControls = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Well = exports.Well = _styledComponents["default"].div.withConfig({
  displayName: "styles__Well",
  componentId: "sc-v2wh61-0"
})(["padding:7px;border:2px dashed #ddd;margin-bottom:10px;"]);
var WellTitle = exports.WellTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__WellTitle",
  componentId: "sc-v2wh61-1"
})(["font-weight:bold;margin-bottom:10px;"]);
var AxisControls = exports.AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "styles__AxisControls",
  componentId: "sc-v2wh61-2"
})(["display:flex;> label{margin-right:15px;}"]);
var LegendsWell = exports.LegendsWell = (0, _styledComponents["default"])(Well).withConfig({
  displayName: "styles__LegendsWell",
  componentId: "sc-v2wh61-3"
})(["opacity:", ";label.disabled,input:disabled{cursor:not-allowed;}"], function (props) {
  return props.disabled ? 0.3 : 1;
});
var TooltipWell = exports.TooltipWell = LegendsWell;